import { runtimeConfig } from '../config/runtime';

/**
 * Whether Entra ID authentication is configured.
 * When the client ID is missing, auth is bypassed entirely (local dev mode).
 */
export const isAuthEnabled = Boolean(runtimeConfig.ENTRA_CLIENT_ID);
